import { render, staticRenderFns } from "./TrafficDataTable.vue?vue&type=template&id=01c10b02&scoped=true&"
import script from "./TrafficDataTable.vue?vue&type=script&lang=js&"
export * from "./TrafficDataTable.vue?vue&type=script&lang=js&"
import style0 from "./TrafficDataTable.vue?vue&type=style&index=0&id=01c10b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c10b02",
  null
  
)

export default component.exports